const formatTotalBalance = (num, curr) => {
  if (num === "xxxx.xx" || isNaN(num) || num === null || num === undefined) {
    let word = { amount: "Redacted", prefix: "", abbr: "" };
    return word;
  }
  let words = { amount: "", prefix: "", abbr: "" };
  const formattedPrice = Intl.NumberFormat(
    curr === "Billions" || curr === "Millions" ? "en-US" : "en-IN",
    {
      currency: curr === "Billions" || curr === "Millions" ? "USD" : "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  ).format(Number(num));

  const [integerPart, decimalPart] = formattedPrice.split(".");
  const paddedIntegerPart = integerPart.padStart(2, "");

  const crore = Number(num) / 10000000;
  const billions = Number(num) / 1000000000;
  const millions = Number(num) / 1000000;
  const lakh = Number(num) / 100000;

  if (curr === "Billions") {
    let val = String(billions).slice(1, billions.length);
    if (String(num).substring(0, 1) === "-" && Math.floor(Number(val)) > 0) {
      words.amount = -(Math.floor(val * 100) / 100).toFixed(2);
      words.prefix = "billions";
      words.abbr = "B";
    } else if (billions > 0) {
      words.amount = (Math.floor(billions * 100) / 100).toFixed(2);
      words.prefix = "billions";
      words.abbr = "B";
    } else {
      words.amount = (Math.floor(billions * 100) / 100).toFixed(2);
      words.prefix = "billions";
      words.abbr = "B";
    }
  } else if (curr === "Millions") {
    let val = String(millions).slice(1, millions.length);
    if (String(num).substring(0, 1) === "-" && Math.floor(Number(val)) > 0) {
      words.amount = -(Math.floor(val * 100) / 100).toFixed(2);
      words.prefix = "millions";
      words.abbr = "M";
    } else if (millions > 0) {
      words.amount = (Math.floor(millions * 100) / 100).toFixed(2);
      words.prefix = "millions";
      words.abbr = "M";
    } else {
      words.amount = (Math.floor(millions * 100) / 100).toFixed(2);
      words.prefix = "millions";
      words.abbr = "M";
    }
  } else if (curr === "Crores") {
    let val = String(crore).slice(1, crore.length);
    if (String(num).substring(0, 1) === "-" && Math.floor(Number(val)) > 0) {
      words.amount = -(Math.floor(val * 100) / 100).toFixed(2);
      words.prefix = "crores";
      words.abbr = "Cr";
    } else if (crore > 0) {
      words.amount = (Math.floor(crore * 100) / 100).toFixed(2);
      words.prefix = "crores";
      words.abbr = "Cr";
    } else {
      words.amount = (Math.floor(crore * 100) / 100).toFixed(2);
      words.prefix = "crores";
      words.abbr = "Cr";
    }
  } else if (curr === "Lakhs") {
    let val = String(lakh).slice(1, lakh.length);
    if (String(num).substring(0, 1) === "-" && Math.floor(Number(val)) > 0) {
      words.amount = -(Math.floor(val * 100) / 100).toFixed(2);
      words.prefix = "lakhs";
      words.abbr = "L";
    } else if (lakh > 0) {
      words.amount = (Math.floor(lakh * 100) / 100).toFixed(2);
      words.prefix = "lakhs";
      words.abbr = "L";
    } else {
      words.amount = (Math.floor(lakh * 100) / 100).toFixed(2);
      words.abbr = "L";
      words.prefix = "lakhs";
    }
  } else if (curr === "amount") {
    words.amount = `${paddedIntegerPart}.${decimalPart}`;
    words.prefix = "amount";
    words.abbr = "amount";
  } else {
    let val = String(crore).slice(1, crore.length);
    if (String(num).substring(0, 1) === "-" && Math.floor(Number(val)) > 0) {
      words.amount = -(Math.floor(val * 100) / 100).toFixed(2);
      words.prefix = "crores";
      words.abbr = "Cr";
    } else if (Math.floor(crore) > 0) {
      words.amount = (Math.floor(crore * 100) / 100).toFixed(2);
      words.prefix = "crores";
      words.abbr = "Cr";
    } else {
      words.amount = `${paddedIntegerPart}.${decimalPart}`;
      words.prefix = "";
      words.abbr = "";
    }
  }

  return words;
};

export default formatTotalBalance;
